import type { GameState, PlayerReceivedItemSource } from './types';
import { appendEvent } from './event-log';

export function grantPlayerItem(
  state: GameState,
  playerId: string,
  itemId: string,
  source: PlayerReceivedItemSource,
): boolean {
  const player = state.players.get(playerId);
  if (!player) return false;

  player.items.push(itemId);
  appendEvent(state, {
    type: 'player_received_item',
    playerId,
    itemId,
    source,
  });
  return true;
}
